export default {
  settings: 'CHAT_SETTINGS',
  updateSettings: 'CHAT_SETTINGS_UPDATE',
};
